<template>
    <PageContentLoader v-if="fetchingOrStale && !ring" />

    <PageErrorFiveHundred
        v-else-if="error"
        :errors="responseErrors"
    >
        <!-- TODO What if this error is in another query-->
        <ThButton
            :loading="fetchingOrStale"
            @click="executePageQuery"
        >
            {{ t('globals.try_again') }}
        </ThButton>
    </PageErrorFiveHundred>

    <div v-else-if="ring">
        <ProductBreadcrumbs :breadcrumbs />

        <div
            :class="{ fetching }"
            class="product-wrapper"
        >
            <div v-if="is3rdStep && imageFor3rdStep">
                <Image
                    v-bind="
                        getGenericImageProps({
                            size: imageFor3rdStep.large_x2,
                        })
                    "
                />
            </div>

            <ProductGallery
                v-else
                :initial-three-sixty-image-index="4"
                :product="ring"
                :see-in-store-cta="countryCode === 'GB'"
                :threedium="threediumControlsOrUndefined"
                data-qa="product-gallery"
            />

            <div class="product-details">
                <div
                    v-qa="'product-information'"
                    :data-qa-product-properties="
                        JSON.stringify({
                            name: ring.productName,
                            metal: ring.primaryMetal.translation.name,
                            stoneShape:
                                ring.centreStoneConstraints.shape.systemCode,
                            signatureStone:
                                ring.signatureStone?.colors[0]?.systemCode,
                            mountPrice: ring?.salePrice.total || {
                                amount: '0',
                                currency: 'GBP',
                            },
                        })
                    "
                    class="product-information"
                >
                    <div class="product-title">
                        <h1
                            v-qa="'ring-name'"
                            class="name"
                        >
                            {{ ring.productName }}
                        </h1>

                        <SaveForLaterButton
                            v-if="!is3rdStep"
                            :product="ring"
                            page-type="pdp"
                        />
                    </div>

                    <ReviewsAggregate
                        v-if="ring.reviewsAggregate.total"
                        :data="ring.reviewsAggregate"
                        :is3rd-step
                    />

                    <p
                        v-qa="'ring-description'"
                        class="description"
                    >
                        {{ ring.translation.description }}
                    </p>

                    <div
                        v-if="!is3rdStep && totalSalePriceBefore3rdStep"
                        class="price-explained-text"
                    >
                        <TaxSnippet
                            v-if="totalSalePriceBefore3rdStep"
                            :data="totalSalePriceBefore3rdStep"
                        />

                        <div class="price-explained-container">
                            <TooltipCustom page-type="product-details">
                                <!-- TODO translate -->
                                <template #label>Price explained</template>

                                <!-- TODO translate -->
                                <template #title>Price explained</template>

                                <!-- TODO translate -->
                                <template #content>
                                    <ul class="price-explainer-list">
                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Ring price
                                            </span>

                                            <span class="value">
                                                <Money
                                                    :data="
                                                        totalSalePriceBefore3rdStep.total
                                                    "
                                                    :formatter
                                                />
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Shipping
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Free & Insured
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Resizing
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Complimentary
                                            </span>
                                        </li>

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Warranty
                                            </span>

                                            <!-- TODO translate -->
                                            <span class="value">
                                                Lifetime
                                            </span>
                                        </li>

                                        <hr class="divider" />

                                        <li class="item">
                                            <!-- TODO translate -->
                                            <span class="label">
                                                Sub-total (choose your centre
                                                stone next)
                                            </span>
                                            <span class="value">
                                                <TaxSnippet
                                                    :data="
                                                        totalSalePriceBefore3rdStep
                                                    "
                                                    :inline="true"
                                                />
                                            </span>
                                        </li>
                                    </ul>
                                </template>
                            </TooltipCustom>

                            <!-- TODO translate -->
                            Note: price excludes centre diamond.
                        </div>
                    </div>

                    <Transition name="step-three">
                        <div
                            v-if="is3rdStep"
                            v-qa="'third-step-container'"
                            :class="classStepThree"
                            class="step-three"
                        >
                            <TaxSnippet
                                v-if="totalSalePrice3rdStep"
                                :data="totalSalePrice3rdStep"
                            />

                            <div class="price-explained-text">
                                <TooltipCustom
                                    v-if="
                                        totalSalePriceBefore3rdStep &&
                                        ringBuilderStone &&
                                        ringBuilderStone.salePrice
                                    "
                                    page-type="product-details"
                                >
                                    <!-- TODO translate -->
                                    <template #label>Price explained</template>

                                    <!-- TODO translate -->
                                    <template #title>Price explained</template>

                                    <!-- TODO translate -->
                                    <template #content>
                                        <ul class="price-explainer-list">
                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Ring price
                                                </span>

                                                <span class="value">
                                                    <Money
                                                        :data="
                                                            totalSalePriceBefore3rdStep.total
                                                        "
                                                        :formatter
                                                    />
                                                </span>
                                            </li>
                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    {{
                                                        ringBuilderStoneTypeLabel
                                                    }}
                                                    price
                                                </span>

                                                <span class="value">
                                                    {{ stonePrice }}
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Shipping
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Free & Insured
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Resizing
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Complimentary
                                                </span>
                                            </li>

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Warranty
                                                </span>

                                                <!-- TODO translate -->
                                                <span class="value">
                                                    Lifetime
                                                </span>
                                            </li>

                                            <hr class="divider" />

                                            <li class="item">
                                                <!-- TODO translate -->
                                                <span class="label">
                                                    Sub-total
                                                </span>
                                                <span class="value">
                                                    <TaxSnippet
                                                        v-if="
                                                            totalSalePrice3rdStep
                                                        "
                                                        :data="
                                                            totalSalePrice3rdStep
                                                        "
                                                        :inline="true"
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </template>
                                </TooltipCustom>
                            </div>

                            <FinanceOptions
                                :affirm="ringBuilder.affirmFinanceOptions.value"
                            />

                            <!-- TODO translate -->
                            <div
                                class="title"
                                role="heading"
                            >
                                Price includes
                            </div>

                            <div
                                v-qa="'item-ring'"
                                class="item ring"
                            >
                                <Image
                                    v-if="ringBuilderRingImage"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    class="image"
                                    fit="contain"
                                    v-bind="
                                        getGenericImageProps({
                                            size: ringBuilderRingImage.small_x2,
                                        })
                                    "
                                />

                                {{ ringBuilderRingDescription }}

                                <div
                                    v-if="!fetchingRingBuilderSetMutation"
                                    class="remove-button"
                                    @click.prevent.stop="removeRing"
                                >
                                    <Icon
                                        class="icon-close"
                                        icon="close"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="ringBuilderStoneImage"
                                v-qa="'item-stone'"
                                class="item stone"
                            >
                                <img
                                    v-if="'url' in ringBuilderStoneImage"
                                    :alt="ringBuilderStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    :src="ringBuilderStoneImage.url"
                                    class="image"
                                />
                                <Image
                                    v-else
                                    :alt="ringBuilderStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    class="image"
                                    v-bind="ringBuilderStoneImage.image"
                                />

                                <div>
                                    {{ ringBuilderStoneDescription }}

                                    <Icon
                                        class="icon-stone-modal-info"
                                        icon="info"
                                        @click="openStoneModal"
                                    />
                                </div>

                                <component
                                    :is="stoneModalComponent.is"
                                    v-if="
                                        isStoneModalOpened &&
                                        stoneModalComponent
                                    "
                                    v-bind="stoneModalComponent.props"
                                    v-on="stoneModalComponent.events"
                                ></component>

                                <div
                                    v-if="!fetchingRingBuilderSetMutation"
                                    class="remove-button"
                                    @click.prevent.stop="removeStone"
                                >
                                    <Icon
                                        class="icon-close"
                                        icon="close"
                                    />
                                </div>
                            </div>

                            <div
                                v-if="
                                    ringBuilderSignatureStoneImg &&
                                    ringBuilderSignatureStoneDescription
                                "
                                class="item stone signature-stone"
                            >
                                <img
                                    :alt="ringBuilderSignatureStoneDescription"
                                    :loading="isMobileAgent ? 'lazy' : 'eager'"
                                    :src="ringBuilderSignatureStoneImg"
                                    class="image"
                                />

                                {{ ringBuilderSignatureStoneDescription }}

                                <LazyTooltip
                                    inline
                                    page-type="product-details"
                                    path="/engagement-ring/signature-stone"
                                />
                            </div>

                            <div class="size-and-engraving">
                                <ThSelect
                                    v-model="ringSizeId"
                                    v-qa="'ring-size'"
                                    :error="ringSizeError"
                                    :legend="'Ring size'"
                                    :options="ringSizeOptions"
                                    :placeholder="'Select'"
                                    class="size"
                                    serif-font
                                >
                                    <template #tooltip>
                                        <LazyTooltip
                                            inline
                                            page-type="product-details"
                                            path="/engagement-ring/ring-size"
                                        />
                                    </template>
                                </ThSelect>

                                <TextField
                                    id="engraving"
                                    v-model="engraving"
                                    :error="errors.last('engraving')"
                                    :label="'Optional engraving'"
                                    :maxlength="engravingMaxLength"
                                    class="engraving"
                                    serif-font
                                >
                                    <template #tooltip>
                                        <LazyTooltip
                                            inline
                                            page-type="product-details"
                                            path="/engagement-ring/engraving"
                                        />
                                    </template>
                                </TextField>
                            </div>
                        </div>
                    </Transition>
                </div>

                <Transition name="product-customization">
                    <div
                        v-if="!is3rdStep"
                        class="product-customization"
                    >
                        <MetalVariations
                            :selected="ring"
                            :variations="metalVariations"
                            @click="
                                (e) =>
                                    trackThreediumFilters(
                                        'metal',
                                        e.primaryMetal.translation.name
                                    )
                            "
                        />

                        <div class="product-variation">
                            <span class="label">
                                {{
                                    t(
                                        'catalogue.engagement_ring.product_customization.center_shape'
                                    )
                                }}:
                                {{
                                    ring.centreStoneConstraints.shape
                                        .translation.name
                                }}

                                <button
                                    class="additional-options"
                                    type="button"
                                    @click="togglesEnquireShape"
                                >
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.title'
                                        )
                                    }}
                                </button>
                            </span>

                            <ul
                                v-if="!isEnquireShapeOpen"
                                :aria-label="
                                    t(
                                        'catalogue.engagement_ring.product_customization.center_shape'
                                    )
                                "
                                class="shape-variations"
                                data-qa="shape-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="(
                                        variation, variationKey
                                    ) in centreStoneVariations"
                                    :key="variationKey"
                                    class="variation"
                                    role="none"
                                >
                                    <ThLink
                                        v-qa="
                                            variation.centreStoneConstraints
                                                .shape.systemCode
                                        "
                                        :aria-label="
                                            variation.centreStoneConstraints
                                                .shape.translation.name
                                        "
                                        :aria-selected="
                                            variation.centreStoneConstraints
                                                .shape.systemCode ===
                                            ring.centreStoneConstraints.shape
                                                .systemCode
                                        "
                                        :to="routes.ring.engagement(variation)"
                                        class="link"
                                        role="option"
                                        @click="
                                            trackThreediumFilters(
                                                'centre_shape',
                                                variation.centreStoneConstraints
                                                    .shape.translation.name
                                            )
                                        "
                                    >
                                        <img
                                            v-if="
                                                variation.centreStoneConstraints
                                                    .shape.icon
                                            "
                                            :alt="
                                                variation.centreStoneConstraints
                                                    .shape.translation.name
                                            "
                                            :loading="
                                                isMobileAgent ? 'lazy' : 'eager'
                                            "
                                            :src="
                                                variation.centreStoneConstraints
                                                    .shape.icon.url
                                            "
                                            class="image"
                                        />

                                        <span
                                            v-else
                                            class="name"
                                        >
                                            {{
                                                variation.centreStoneConstraints
                                                    .shape.translation.name
                                            }}
                                        </span>
                                    </ThLink>
                                </li>
                            </ul>

                            <div
                                v-else
                                class="enquire-shape"
                            >
                                <span class="title">
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.title'
                                        )
                                    }}
                                </span>

                                <p>
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.description'
                                        )
                                    }}
                                </p>

                                <ThButton
                                    :loading="fetchingCreateShapeEnquiry"
                                    :text-size="14"
                                    class="th-button"
                                    color="var(--white)"
                                    type="link"
                                    @click="handleShapeEnquiryButton"
                                >
                                    {{
                                        t(
                                            'catalogue.engagement_ring.prefer_another_shape.button'
                                        )
                                    }}
                                </ThButton>

                                <button
                                    class="enquire-shape-close"
                                    type="button"
                                    @click="togglesEnquireShape"
                                >
                                    <Icon icon="close" />
                                </button>
                            </div>
                        </div>

                        <div
                            v-if="
                                ring &&
                                threediumControlsOrUndefined &&
                                caratSizes
                            "
                            class="product-variation"
                        >
                            <span class="label">
                                <!-- todo translate-->
                                Carat Size:
                                <!--                                <LazyTooltip-->
                                <!--                                    inline-->
                                <!--                                    path="/engagement-ring/signature-stone"-->
                                <!--                                />-->
                            </span>

                            <ul
                                aria-label="Carat Size variations"
                                class="threedium-type-test-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="size in caratSizes"
                                    :key="size.val"
                                    :class="{
                                        active:
                                            size.val === currentCaratSize.val,
                                    }"
                                    class="variation"
                                    role="none"
                                >
                                    <ThLink
                                        :aria-label="size.name"
                                        :aria-selected="
                                            size.val === currentCaratSize.val
                                        "
                                        role="option"
                                        @click="setThreediumCaratSize(size)"
                                    >
                                        {{ size.name }}
                                    </ThLink>
                                </li>
                            </ul>
                        </div>

                        <div
                            v-if="ring && threediumControlsOrUndefined"
                            class="product-variation"
                        >
                            <span class="label">
                                <!-- todo translate-->
                                Side stones:
                                <!--                                <LazyTooltip-->
                                <!--                                    inline-->
                                <!--                                    path="/engagement-ring/signature-stone"-->
                                <!--                                />-->

                                {{ currentSideStoneLabel }}
                            </span>

                            <ul
                                aria-label="Side stones variations"
                                class="threedium-type-test-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="(
                                        sideColour, key
                                    ) in sideStoneColours"
                                    :key="key"
                                    :class="{
                                        active:
                                            sideColour ===
                                            currentSideStoneColour,
                                    }"
                                    class="variation"
                                    role="none"
                                >
                                    <ThLink
                                        :aria-label="sideColour"
                                        :aria-selected="
                                            sideColour ===
                                            currentSideStoneColour
                                        "
                                        :to="
                                            routes.ring.engagement({
                                                ...ring,
                                                suffixSlug: getSuffixFor(
                                                    currentBandType,
                                                    sideColour
                                                ),
                                            })
                                        "
                                        role="option"
                                        @click="
                                            trackThreediumFilters(
                                                'side_stones',
                                                sideColour
                                            )
                                        "
                                    >
                                        <img
                                            v-if="'green' === sideColour"
                                            :alt="sideColour"
                                            src="https://cms-media.taylorandhart.com/2023/06/06103915/green-sapphier.png"
                                        />
                                        <img
                                            v-else-if="'ruby' === sideColour"
                                            :alt="sideColour"
                                            src="https://cms-media.taylorandhart.com/2023/06/06103631/Ruby-1.png"
                                        />
                                        <img
                                            v-else-if="'purple' === sideColour"
                                            :alt="sideColour"
                                            src="@/assets/purple_sapphire.png"
                                        />
                                        <img
                                            v-else-if="'pink' === sideColour"
                                            :alt="sideColour"
                                            src="https://cms-media.taylorandhart.com/2023/06/06103658/Pink-sapphire.png"
                                        />
                                        <img
                                            v-else-if="'diamond' === sideColour"
                                            :alt="sideColour"
                                            src="https://cms-media.taylorandhart.com/2023/06/06103713/white-diamond.png"
                                        />
                                    </ThLink>
                                </li>
                            </ul>
                        </div>

                        <div
                            v-if="ring && threediumControlsOrUndefined"
                            class="product-variation"
                        >
                            <span class="label">
                                <!-- todo translate-->
                                Band Type:
                                <!--                                <LazyTooltip-->
                                <!--                                    inline-->
                                <!--                                    path="/engagement-ring/signature-stone"-->
                                <!--                                />-->
                            </span>

                            <ul
                                aria-label="Band Type variations"
                                class="threedium-type-test-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="(type, index) in bandTypes"
                                    :key="index"
                                    :class="{
                                        active: type === currentBandType,
                                    }"
                                    class="variation band-type"
                                    role="none"
                                >
                                    <ThLink
                                        :aria-label="getBandTypeName(type)"
                                        :aria-selected="
                                            type === currentBandType
                                        "
                                        :to="
                                            routes.ring.engagement({
                                                ...ring,
                                                suffixSlug: getSuffixFor(
                                                    type,
                                                    currentSideStoneColour
                                                ),
                                            })
                                        "
                                        role="option"
                                        @click="
                                            trackThreediumFilters(
                                                'band_type',
                                                getBandTypeName(type)
                                            )
                                        "
                                    >
                                        {{ getBandTypeName(type) }}
                                    </ThLink>
                                </li>
                            </ul>
                        </div>

                        <!--                        <div class="product-variation">-->
                        <!--                            <span class="label"> See on Hand </span>-->

                        <!--                            <div>-->
                        <!--                                <ThButton-->
                        <!--                                    :color="-->
                        <!--                                        seeOnHand-->
                        <!--                                            ? 'var(&#45;&#45;blue)'-->
                        <!--                                            : 'var(&#45;&#45;blush)'-->
                        <!--                                    "-->
                        <!--                                    @click="toggleSeeOnHand"-->
                        <!--                                >-->
                        <!--                                    {{-->
                        <!--                                        seeOnHand-->
                        <!--                                            ? 'See ring only'-->
                        <!--                                            : 'See on hand'-->
                        <!--                                    }}-->
                        <!--                                </ThButton>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                        <div class="product-variation">
                            <span
                                v-if="signatureStoneLabel"
                                class="label"
                            >
                                {{
                                    t(
                                        'catalogue.engagement_ring.product_customization.signature_stone'
                                    )
                                }}:
                                {{ signatureStoneLabel }}
                                <LazyTooltip
                                    inline
                                    page-type="product-details"
                                    path="/engagement-ring/signature-stone"
                                />
                            </span>

                            <ul
                                aria-label="Signature Stone Variations"
                                class="signature-stone-variations"
                                role="listbox"
                            >
                                <li
                                    v-for="(
                                        { signatureStone: sigStone }, index
                                    ) in ring.signatureStones"
                                    :key="index"
                                    :aria-label="
                                        getSignatureStoneLabel(sigStone)
                                    "
                                    :aria-selected="
                                        getIsActiveSignatureStoneVariation(
                                            sigStone
                                        )
                                    "
                                    :class="
                                        getClassSignatureStoneVariation(
                                            sigStone
                                        )
                                    "
                                    class="variation"
                                    role="option"
                                    tabindex="0"
                                    @click.prevent.stop="
                                        setSignatureStone(
                                            sigStone,
                                            getSignatureStoneLabel(sigStone)
                                        )
                                    "
                                    @keypress.enter.prevent.stop="
                                        setSignatureStone(
                                            sigStone,
                                            getSignatureStoneLabel(sigStone)
                                        )
                                    "
                                >
                                    <img
                                        :alt="getSignatureStoneLabel(sigStone)"
                                        :loading="
                                            isMobileAgent ? 'lazy' : 'eager'
                                        "
                                        :src="sigStone.image"
                                        :title="
                                            getSignatureStoneLabel(sigStone)
                                        "
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </Transition>

                <DeliveryTimeframe
                    v-if="deliveryDate"
                    :data="deliveryDate"
                />

                <DeliveryTimeframeExpress v-if="ring.supportsExpress" />

                <CtaBox
                    :data="responsePage.data.value?.pageProductDetails"
                    :disabled="!is3rdStep"
                >
                    <template #default>
                        <div class="product-cta">
                            <!-- TODO: set data-qa per cta case -->
                            <div
                                v-if="is3rdStep && !isValidCreation"
                                class="enquiry-message"
                            >
                                This combination cannot be checked out
                                automatically. Please make an enquiry.
                            </div>

                            <AddToCartFloatingButton>
                                <template #button>
                                    <ThButton
                                        :full-width="true"
                                        :loading="isActionDisabled"
                                        type="solid"
                                        @click="handleCta"
                                    >
                                        {{ ctaLabel }}
                                    </ThButton>
                                </template>
                            </AddToCartFloatingButton>
                        </div>
                    </template>

                    <template #below-cta>
                        <SaveForLaterButton
                            v-if="!is3rdStep"
                            :product="ring"
                            below-cta
                            page-type="pdp"
                        />

                        <div
                            v-if="is3rdStep && isValidCreation"
                            class="customize-further"
                        >
                            <ThButton
                                v-qa="'customize-further'"
                                :full-width="true"
                                :loading="isActionDisabled"
                                type="link"
                                @click="handleCustomizeFurther"
                            >
                                <!-- TODO translate -->
                                Customise further
                            </ThButton>
                        </div>
                    </template>
                </CtaBox>

                <PdpAccordion
                    :items="
                        responsePage.data.value?.pageProductDetails
                            ?.accordionItems ?? []
                    "
                    :product="ring"
                    :related-products="{
                        products: ring.relatedProducts,
                    }"
                    :resizeable="ring.isResizeable"
                    about-this-entity-label="ring"
                >
                    <template #aboutThisProduct>
                        <div class="product-additional-details">
                            <div
                                v-if="ring?.translation?.seoText"
                                class="product-description"
                            >
                                <!-- eslint-disable vue/no-v-html -->
                                <p
                                    class="description"
                                    v-html="
                                        localizeHrefs(ring.translation.seoText)
                                    "
                                ></p>
                            </div>

                            <ProductProperties
                                v-if="productPropertiesData"
                                :data="productPropertiesData"
                            />

                            <AccentGems
                                v-if="ring?.accentGemItems.length"
                                :accent-gems="ring.accentGemItems"
                            />
                        </div>
                    </template>
                </PdpAccordion>

                <AuthFormInModal
                    ref="authForm"
                    :content
                    :is-open="isEnquiryModalOpen"
                    :registration-disabled="isActionDisabled"
                    :registration-errors="errors"
                    @close="closeEnquiryModal"
                    @login="
                        (_, type) => {
                            if (type === 'manual') handleModalLogin()
                        }
                    "
                    @register="handleModalSubmit"
                />

                <ThDialog
                    :confirm-label="'Yes'"
                    :is-open="isAddToRingBuilderDialogOpen"
                    :prompt="'Change your ring selection to this one?'"
                    @close="closeAddToRingBuilderDialog"
                    @confirm="confirmAddToRingBuilder"
                />
            </div>
        </div>

        <CmsBlocks
            :data="cmsBlocks"
            :product="ring"
            :related-products="{
                products: ring.relatedProducts,
            }"
            page-type="product-details"
        />

        <Reviews :data="ring.reviews" />
    </div>

    <PageErrorFourHundredFour v-else />
</template>

<script lang="ts" setup>
import {
    computed,
    defineAsyncComponent,
    hydrateOnIdle,
    hydrateOnVisible,
    type Ref,
    ref,
    toRef,
    useTemplateRef,
    watch,
} from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'

import type {
    CatalogueEngagementRingFragment,
    CatalogueEngagementRingSignatureStoneInput,
    SignatureStoneInputFragment,
    TaxSnippetFragment,
} from '@/graphql/api'
import { useLastResponseErrorAtPath, useResponseError } from '@/helpers/errors'
import { assertNever } from '@/helpers'
import { useRoutes } from '@/router/routes'
import { useProductPageMeta } from '@/views/product/composables/useProductPageMeta'
import {
    getSignatureStoneLabel,
    useEngagementRingData,
} from './composables/useEngagementRingData'
import { useEngagementRingBreadcrumbs } from './composables/useEngagementRingBreadcrumbs'
import { useEngagementRingAddToCart } from './composables/useEngagementRingAddToCart'
import { useEngagementRing3rdStep } from './composables/useEngagementRing3rdStep'
import { useEngagementRingAnalytics } from './composables/useEngagementRingAnalytics'
import { useEngagementRingCreateShapeEnquiry } from './composables/useEngagementRingCreateShapeEnquiry'
import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import { useEngagementRingCreateEnquiry } from './composables/useEngagementRingCreateEnquiry'
import { signatureStoneToInput } from '@/domain/product/ring/engagement'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'
import { useIsMobileAgent } from '@/plugins/is-mobile-agent.ts'
import { getGenericImageProps } from '@/components/useImageProps'
import { useAbsoluteUrl } from '@/composables/app/useAbsoluteUrl'
import { useProductAnalytics } from '@/views/product/composables/analytics/useProductAnalytics'
import { useScrollIntoView } from '../composables/ui/useScrollIntoView'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'
import { useHrefLocalizer } from '@/router/href-localizer'
import { useWindowScroll } from '@vueuse/core'
import { useEngagementRing3rdStepStoneModal } from '@/views/product/engagement-ring/composables/useEngagementRing3rdStepStoneModal.ts'
import { useRedirect } from 'wucdbm-vite-vue-ssr'

import MetalVariations from '@/components/rings/MetalVariations.vue'
import ThButton from '@/components/ui/buttons/ThButton.vue'
import ProductBreadcrumbs from '@/components/rings/ProductBreadcrumbs.vue'
import ThSelect from '@/components/ui/inputs/ThSelect.vue'
import TextField from '@/components/ui/inputs/TextField.vue'
import Icon from '@/components/ui/icon/Icon.vue'
import TooltipCustom from '@/components/layout/tooltip/TooltipCustom.vue'
import DeliveryTimeframe from '@/components/rings/DeliveryTimeframe.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import FinanceOptions from '@/components/rings/FinanceOptions.vue'
import Image from '@/components/Image.vue'
import Money from '@/components/Money.vue'
import TaxSnippet from '@/components/rings/TaxSnippet.vue'
import ThDialog from '@/components/layout/modal/ThDialog.vue'
import ProductGallery from '@/components/layout/gallery/ProductGallery.vue'
import LazyTooltip from '@/components/layout/tooltip/LazyTooltip.vue'
import { useAuth } from '@/plugins/auth.ts'
import PageContentLoader from '@/components/ui/PageContentLoader.vue'
import { type EngagementRingProps } from '@/views/product/engagement-ring/er.ts'
import {
    useEngagementRingSize,
    useImageFor3rdStep,
    useRingBuilder,
    useRingBuilderStoneTypeLabel,
} from '@/plugins/ring-builder.ts'
import ReviewsAggregate from '@/components/rings/ReviewsAggregate.vue'
import { useIsMobile } from '@/plugins/is-mobile.ts'
import SaveForLaterButton from '@/components/saved-products/SaveForLaterButton.vue'
import {
    type ThreediumCaratSize,
    type ThreediumControls,
    type ThreediumInitParameters,
    type ThreediumMetal,
    useThreedium,
    useThreediumValues,
} from '@/views/product/engagement-ring/threedium.ts'
import PdpAccordion from '@/components/product/PdpAccordion.vue'
import AccentGems from '@/components/product/AccentGems.vue'
import type { ProductPropertiesData } from '@/components/product/ProductProperties.vue'
import ProductProperties from '@/components/product/ProductProperties.vue'
import DeliveryTimeframeExpress from '@/components/rings/DeliveryTimeframeExpress.vue'
import AuthFormInModal from '@/components/user/auth/AuthFormInModal.vue'
import { useInit } from '@/plugins/init/use-init.ts'
import AddToCartFloatingButton from '../components/AddToCartFloatingButton.vue'
import CtaBox from '../components/CtaBox.vue'
import { useCountryPlugin } from '@/plugins/country.ts'

const { countryCode } = useCountryPlugin()

const PageErrorFiveHundred = defineAsyncComponent({
    loader: () => import('@/components/PageErrorFiveHundred.vue'),
    hydrate: hydrateOnVisible(),
})

const PageErrorFourHundredFour = defineAsyncComponent({
    loader: () => import('@/components/PageErrorFourHundredFour.vue'),
    hydrate: hydrateOnVisible(),
})

const CmsBlocks = defineAsyncComponent({
    loader: () => import('@/components/cms/CmsBlocks.vue'),
    hydrate: hydrateOnIdle(),
})

const Reviews = defineAsyncComponent({
    loader: () => import('@/components/rings/Reviews.vue'),
    hydrate: hydrateOnVisible(),
})

export type EngagementRingEnquiry =
    | 'enquiry'
    | 'add-to-cart'
    | 'shape-enquiry'
    | 'custom-enquiry'

const props = defineProps<EngagementRingProps>()

const formatter = useMoneyFormatter()
const localizeHrefs = useHrefLocalizer()

const engraving = ref('')
const engravingMaxLength = 25

const ringBuilder = useRingBuilder()

const { enquiryFormContent } = useInit()

const hasEngraving = computed(() => Boolean(engraving.value.length))

const absoluteUrl = useAbsoluteUrl()
const router = useRouter()
const routes = useRoutes()
const redirect = useRedirect()

const {
    fetching,
    stale,
    ring,
    error,
    responsePage,
    cmsBlocks,
    executePageQuery,
    is3rdStep,
    isValidCreation,
    deliveryDate,
    signatureStone,
    signatureStoneOutput,
    signatureStoneLabel,
} = await useEngagementRingData(props, hasEngraving, ringBuilder)

const redirectIfNeeded = async () => {
    if (
        ring.value &&
        (ring.value.slug !== props.slug ||
            ring.value.suffixSlug !== props.suffixSlug ||
            ring.value.centreStoneConstraints.shape.systemCode !==
                props.shape ||
            ring.value.primaryMetal.systemCode !== props.metal)
    ) {
        await redirect(
            router.resolve(routes.ring.engagement(ring.value)).href,
            301
        )
    }
}

watch(ring, redirectIfNeeded)

await redirectIfNeeded()

const { loadPromise } = ringBuilder
// This is to ensure that RBuilder's data has been loaded, if any
// 1. 3rd step image
// 2. er ring size list
// 3. cta label
// Those above & others will lead to mismatch unless RB is awaited
await loadPromise

// Always use 1st step canonical URL
useHead({
    link: computed(() => {
        if (!ring.value) {
            return []
        }

        return [
            {
                rel: 'canonical',
                href: absoluteUrl(
                    router.resolve(routes.ring.engagement(ring.value))
                ).href,
            },
        ]
    }),
})

const fetchingOrStale = computed(() => fetching.value || stale.value)

const totalSalePriceBefore3rdStep = toRef(
    (): TaxSnippetFragment | undefined => {
        return signatureStoneOutput.value?.salePrice
    }
)

const {
    open: openStoneModal,
    isOpen: isStoneModalOpened,
    component: stoneModalComponent,
} = useEngagementRing3rdStepStoneModal(ringBuilder)

const ringBuilderStoneTypeLabel = useRingBuilderStoneTypeLabel()

const totalSalePrice3rdStep = ringBuilder.salePrice

const {
    addRing,
    removeRing,
    removeStone,
    ring: ringBuilderRing,
    fetchingRingBuilderSetMutation,
    stone: ringBuilderStone,
    stonePrice,
    // handleRingSizeNotSelected,
    // ringSizeError,
    // ringSizeId,
    // ringSizeOptions,
    signatureStone: rbSignatureStone,
    stoneUri: ringBuilderStoneUri,
} = ringBuilder

const imageFor3rdStep = useImageFor3rdStep()

const {
    handleRingSizeNotSelected,
    ringSizeError,
    ringSizeId,
    ringSizeOptions,
} = useEngagementRingSize()

const responseErrors = useResponseError(responsePage)

const productPropertiesData = computed<
    ProductPropertiesData | undefined | null
>(
    () =>
        ring.value && {
            title: 'Details',
            sections: [
                {
                    heading: 'Centre shape',
                    definition:
                        ring.value.centreStoneConstraints.shape.translation
                            .name,
                },
                {
                    heading: 'Metal',
                    definition: ring.value.primaryMetal.translation.name,
                },
                {
                    heading: 'Band width',
                    definition: `${ring.value.bandWidth}mm`,
                },
            ],
        }
)

const metalVariations = computed(
    () => ring.value?.variationsByPrimaryMetal || []
)
const centreStoneVariations = computed(
    () => ring.value?.variationsByCentreStoneShape || []
)

const isMobileAgent = useIsMobileAgent()

const {
    ringBuilderStoneDescription,
    ringBuilderStoneImage,
    ringBuilderRingImage,
    ringBuilderRingDescription,
    ringBuilderSignatureStoneImg,
    ringBuilderSignatureStoneDescription,
} = useEngagementRing3rdStep(ringBuilder)

const getIsActiveSignatureStoneVariation = (
    stone: SignatureStoneInputFragment
) =>
    signatureStone.value?.color === stone.color.systemCode &&
    signatureStone.value?.crystal === stone.crystal.systemCode

const getClassSignatureStoneVariation = (
    stone: SignatureStoneInputFragment
) => ({
    active: getIsActiveSignatureStoneVariation(stone),
})

const setSignatureStone = (
    stone: SignatureStoneInputFragment,
    label: string
) => {
    const input = signatureStoneToInput(stone)

    signatureStone.value = input
    rbSignatureStone.value = input

    trackThreediumFilters('signature_stone', label)
}

// Add to RB
const { routerPush } = useRouterNavigation()

const isAddToRingBuilderDialogOpen = ref(false)
const openAddToRingBuilderDialog = () => {
    isAddToRingBuilderDialogOpen.value = true
}
const closeAddToRingBuilderDialog = () => {
    isAddToRingBuilderDialogOpen.value = false
}

const promptOrAddToRingBuilder = () => {
    if (
        ringBuilderRing.value &&
        ringBuilderRing.value.catalogueCode !== ring.value?.catalogueCode
    ) {
        openAddToRingBuilderDialog()
    } else {
        addToRingBuilder()
    }
}

const confirmAddToRingBuilder = () => {
    addToRingBuilder()
    closeAddToRingBuilderDialog()
}

const { scrollIntoView: scrollIntoViewStepThree } = useScrollIntoView(
    '.step-three',
    {
        left: 0,
        top: 120,
    }
)

const addToRingBuilder = () => {
    if (ring.value) {
        addRing(ring.value, signatureStone.value).then(() => {
            if (!ringBuilderStone.value || !ringBuilder.isValid.value) {
                routerPush(
                    routes.ringBuilder.recommendations('lab-grown-diamonds')
                )
            } else {
                scrollIntoViewStepThree()
            }
        })
    }
}

const isMobile = useIsMobile()
const { y } = useWindowScroll()

watch([() => props.shape, () => props.metal], () => {
    if (!isMobile.value) {
        return
    }

    y.value = 0
})

// User input
const { customerRegistrationInput } = storeToRefs(
    useCustomerRegistrationInputStore()
)

const ringBuilderIf3rdStep = computed(() =>
    is3rdStep.value ? ringBuilder : undefined
)

const authForm = useTemplateRef('authForm')

// Add to cart
const {
    addToCartNewCustomer,
    addToCartErrors,
    addToCartExistingCustomer,
    fetchingAddToCart,
} = useEngagementRingAddToCart(
    ring,
    ringBuilderIf3rdStep,
    ringBuilderStoneUri,
    engraving,
    customerRegistrationInput,
    handleRingSizeNotSelected,
    authForm
)
// Enquiry
const {
    createEnquiryExistingCustomer,
    createEnquiryNewCustomer,
    createEnquiryErrors,
    fetchingCreateEnquiry,
    createEnquiryCustomizeFurtherExistingCustomer,
    createEnquiryCustomizeFurtherNewCustomer,
} = useEngagementRingCreateEnquiry(
    ringBuilderStoneUri,
    engraving,
    customerRegistrationInput,
    handleRingSizeNotSelected,
    authForm
)

const handleCustomizeFurther = () => {
    if (isLogged.value) {
        createEnquiryCustomizeFurtherExistingCustomer()
    } else {
        openEnquiryModal('custom-enquiry')
    }
}

// Shape enquiry
const isEnquireShapeOpen = ref(false)

const togglesEnquireShape = () => {
    isEnquireShapeOpen.value = !isEnquireShapeOpen.value
}

const {
    createShapeEnquiryExistingCustomer,
    createShapeEnquiryNewCustomer,
    fetchingCreateShapeEnquiry,
    shapeEnquiryErrors,
} = useEngagementRingCreateShapeEnquiry(
    ring,
    customerRegistrationInput,
    authForm
)

const handleShapeEnquiryButton = () => {
    if (isLogged.value) {
        createShapeEnquiryExistingCustomer()
    } else {
        openEnquiryModal('shape-enquiry')
    }
}

// the button should be disabled after sending a mutation but also
// when stone and ring validation is running
const isActionDisabled = computed(
    () =>
        fetchingAddToCart.value ||
        fetchingCreateEnquiry.value ||
        fetchingCreateShapeEnquiry.value ||
        fetchingRingBuilderSetMutation.value
)

const errors = useLastResponseErrorAtPath([
    ...addToCartErrors,
    ...createEnquiryErrors,
    ...shapeEnquiryErrors,
])

// Enquiry modal
const { isLogged } = useAuth()

const enquiryType = ref<EngagementRingEnquiry | null>(null)

const openEnquiryModal = (type: EngagementRingEnquiry) => {
    const ringSizeValue = handleRingSizeNotSelected()

    if (!ringSizeValue && type !== 'shape-enquiry') {
        return
    }

    enquiryType.value = type
}

const closeEnquiryModal = () => {
    enquiryType.value = null
}

const isEnquiryModalOpen = computed(() => enquiryType.value !== null)

const content = computed(() => {
    switch (enquiryType.value) {
        case 'add-to-cart':
            return enquiryFormContent.value['engagement-rings-add-to-cart']
        case 'enquiry':
            return enquiryFormContent.value['engagement-rings-enquiry']
        case 'shape-enquiry':
            return enquiryFormContent.value['engagement-rings-shape-enquiry']
        case 'custom-enquiry':
            return enquiryFormContent.value[
                'engagement-rings-customize-further'
            ]
        case null:
            return undefined
        default:
            return assertNever(enquiryType.value, undefined)
    }
})

// CTA button
const handleCta = () => {
    if (is3rdStep.value) {
        if (!isValidCreation.value) {
            if (isLogged.value) {
                createEnquiryExistingCustomer()
            } else {
                openEnquiryModal('enquiry')
            }
        } else {
            if (isLogged.value) {
                addToCartExistingCustomer()
            } else {
                openEnquiryModal('add-to-cart')
            }
        }
    } else {
        promptOrAddToRingBuilder()
    }
}

// TODO translate
const ctaLabel = computed(() => {
    if (is3rdStep.value) {
        if (!isValidCreation.value) {
            return 'Enquire now'
        }

        return 'Add to Cart'
    } else {
        return ringBuilderStone.value
            ? 'Next: Personalise your ring'
            : 'Next: Choose your gem'
    }
})

const handleModalSubmit = (successCallback: () => void) => {
    switch (enquiryType.value) {
        case 'shape-enquiry':
            createShapeEnquiryNewCustomer(successCallback)
            break
        case 'add-to-cart':
            addToCartNewCustomer(successCallback)
            break
        case 'enquiry':
            createEnquiryNewCustomer(successCallback)
            break
        case 'custom-enquiry':
            createEnquiryCustomizeFurtherNewCustomer(successCallback)
            break
        case null:
            break
        default:
            assertNever(enquiryType.value, enquiryType.value)
    }
}

const handleModalLogin = () => {
    switch (enquiryType.value) {
        case 'shape-enquiry':
            createShapeEnquiryExistingCustomer()
            break
        case 'add-to-cart':
            addToCartExistingCustomer()
            break
        case 'enquiry':
            createEnquiryExistingCustomer()
            break
        case 'custom-enquiry':
            createEnquiryCustomizeFurtherExistingCustomer()
            break
        case null:
            break
        default:
            assertNever(enquiryType.value, enquiryType.value)
    }
}

const classStepThree = computed(() => ({
    fetching: fetchingRingBuilderSetMutation.value,
}))

// Misc
const breadcrumbs = useEngagementRingBreadcrumbs(ring)

useProductPageMeta(
    computed(() => responsePage.data.value?.pageProductDetails?.meta),
    ring,
    fetchingOrStale,
    stale,
    ringBuilderIf3rdStep
)

useEngagementRingAnalytics(is3rdStep, ring, ringBuilderStone, fetchingOrStale)

useProductAnalytics(ring, fetching, ringBuilderIf3rdStep)

const { t } = useI18n()

const bandTypes = ['plain', 'pave'] as const
type BandType = (typeof bandTypes)[number]
const sideStoneColours = ['green', 'pink', 'ruby', 'purple', 'diamond'] as const
type SideStoneColour = (typeof sideStoneColours)[number]

const currentBandType = computed<BandType>(() => {
    if (props.suffixSlug.includes('pave')) {
        return 'pave'
    }

    return 'plain'
})

const currentSideStoneColour = computed((): SideStoneColour | undefined => {
    if (props.suffixSlug.includes('green')) {
        return 'green'
    }

    if (props.suffixSlug.includes('pink')) {
        return 'pink'
    }

    if (props.suffixSlug.includes('ruby')) {
        return 'ruby'
    }

    if (props.suffixSlug.includes('purple')) {
        return 'purple'
    }

    return 'diamond'
})

function getSuffixFor(
    bandType: BandType,
    sideStoneColour: SideStoneColour | undefined
): string {
    const suffix: string[] = []

    if ('pave' === bandType) {
        suffix.push('pave')
    }

    if (undefined !== sideStoneColour && 'diamond' !== sideStoneColour) {
        suffix.push(sideStoneColour)
    }

    if (suffix.length === 0) {
        return ''
    }

    return suffix.join('-')
}

const currentSideStoneLabel = computed(() => {
    const crystal =
        ring.value?.accentGemItems[0]?.melee.crystal?.translation.name
    const color =
        crystal === 'Natural Diamond'
            ? ''
            : ring.value?.accentGemItems[0]?.melee.colors[0]?.translation.name

    return `${color} ${crystal}`
})

const threediumValues = useThreediumValues()
const { caratSizes } = threediumValues

const threediumControlsOrUndefined = computed(
    (): ThreediumControls | undefined => {
        return 'Thia' === ring.value?.productName ? threedium : undefined
    }
)

watch(ring, (n, o) => {
    onRingChange(n, o, true)
})

function getThreediumParameters(
    ring: CatalogueEngagementRingFragment | null | undefined
): ThreediumInitParameters {
    if (!ring) {
        return {
            threediumMetal: undefined,
            centreStoneShape: undefined,
            sideStone: undefined,
            band: undefined,
        }
    }

    const { metals, shapes, sideStones, bands } = threediumValues

    const metal = ring.primaryMetal

    const threediumMetal: ThreediumMetal | undefined = metals.find((m) => {
        if ('PLATINUM' === metal.element.systemCode) {
            return m.mod === 'Platinum'
        }

        if ('GOLD' === metal.element.systemCode) {
            switch (metal.color?.systemCode) {
                case 'YELLOW':
                    return m.mod === 'Yellow Gold'
                case 'WHITE':
                    return m.mod === 'White Gold'
                case 'ROSE':
                    return m.mod === 'Rose Gold'
            }
        }

        return true
    })

    const centreStoneShape = shapes.find((s) => {
        switch (ring.centreStoneConstraints.shape.systemCode) {
            case 'EMERALD':
                return s.name === 'Emerald'
            case 'OVAL':
                return s.name === 'Oval'
            case 'RADIANT':
                return s.name === 'Radiant'
            case 'ROUND':
                return s.name === 'Round'
        }

        return s.name === 'Round'
    })

    const sideStone = sideStones.find((s) => {
        if ('ruby' === currentSideStoneColour.value) {
            return s.name === 'Ruby'
        }

        if ('green' === currentSideStoneColour.value) {
            return s.name === 'Green Sapphire'
        }

        if ('purple' === currentSideStoneColour.value) {
            return s.name === 'Purple Sapphire'
        }

        if ('pink' === currentSideStoneColour.value) {
            return s.name === 'Pink Sapphire'
        }

        if ('diamond' === currentSideStoneColour.value) {
            return s.name === 'Diamond'
        }

        return s.name === 'Diamond'
    })

    const band = bands.find((b) => {
        if ('plain' === currentBandType.value) {
            return b.name === 'Plain band'
        }

        if ('pave' === currentBandType.value) {
            return b.name === 'Diamond band'
        }

        return b.name === 'Plain band'
    })

    return {
        threediumMetal,
        centreStoneShape,
        sideStone,
        band,
    }
}

const getBandTypeName = (band: BandType) => {
    switch (band) {
        case 'pave':
            return 'Diamond'
        case 'plain':
            return 'Plain'
        default:
            return assertNever(band, '')
    }
}

const threedium = useThreedium()
const { trackThreediumFilters } = threedium

threedium.onLoad(async () => {
    onRingChange(ring.value, null, false)
    onSignatureStoneChange(signatureStone.value, undefined)

    threedium.isPrepared.value = true
})

const { selectCaratSize } = threedium
const currentCaratSize: Ref<ThreediumCaratSize> = ref(caratSizes[0]!)

function setThreediumCaratSize(size: ThreediumCaratSize) {
    currentCaratSize.value = size

    selectCaratSize(size, true)

    trackThreediumFilters('carat_size', size.name)
}

async function onRingChange(
    v: CatalogueEngagementRingFragment | null | undefined,
    o: CatalogueEngagementRingFragment | null | undefined,
    animate: boolean
): Promise<void> {
    if (threedium.loading.value) {
        return
    }
    const parameters = getThreediumParameters(v)

    if (!v) {
        return
    }

    if (
        parameters.threediumMetal &&
        v.primaryMetal.systemCode !== o?.primaryMetal.systemCode
    ) {
        const { selectMetal } = threedium

        await selectMetal(parameters.threediumMetal, animate)

        if (animate) {
            return
        }
    }

    if (
        parameters.centreStoneShape &&
        v.centreStoneConstraints.shape.systemCode !==
            o?.centreStoneConstraints.shape.systemCode
    ) {
        const { selectShape } = threedium

        await selectShape(parameters.centreStoneShape, animate)

        if (animate) {
            return
        }
    }

    // Initial load
    if (!o) {
        const { selectBand } = threedium

        if (parameters.band) {
            await selectBand(parameters.band, animate)

            if (animate) {
                return
            }
        }

        if (parameters.sideStone) {
            const { selectSideStone } = threedium

            await selectSideStone(parameters.sideStone, animate)

            if (animate) {
                return
            }
        }

        return
    }

    if (v.accentGemItems.length !== o.accentGemItems.length) {
        if (parameters.band) {
            const { selectBand } = threedium

            await selectBand(parameters.band, animate)

            if (animate) {
                return
            }
        }
    } else {
        if (parameters.sideStone) {
            const { selectSideStone } = threedium

            await selectSideStone(parameters.sideStone, animate)

            if (animate) {
                return
            }
        }
    }
}

const isFirstSigStoneChange = ref(true)
async function onSignatureStoneChange(
    v: CatalogueEngagementRingSignatureStoneInput | undefined,
    o: CatalogueEngagementRingSignatureStoneInput | undefined
): Promise<void> {
    const { signatureStones } = threediumValues
    const { selectSignatureStone, loading } = threedium
    if (loading.value) {
        return
    }

    if (!v) {
        return
    }

    if (v.color === o?.color && v.crystal === o.crystal) {
        return
    }

    const threediumSignatureStone = signatureStones.find((s) => {
        return (
            v?.color === s.colourSystemCode &&
            v?.crystal === s.crystalSystemCode
        )
    })

    if (threediumSignatureStone) {
        const animate = !isFirstSigStoneChange.value
        isFirstSigStoneChange.value = false

        await selectSignatureStone(threediumSignatureStone, animate)
    }
}

watch(signatureStone, onSignatureStoneChange)
</script>

<style lang="scss" scoped>
.product-additional-details {
    .description {
        font-size: 1rem;
        line-height: 1.6em;
        padding: 0 0 20px;
    }
}

.price-explained-text {
    :deep(.tooltip-trigger) {
        &:after {
            font-size: 1rem;
            margin-left: 1px;
        }
    }
}

.price-explainer-list {
    padding: 10px 15px;

    @include min-width(640) {
        padding: 0;
    }

    .item {
        margin-bottom: 15px;

        @include min-width(640) {
            display: flex;
            justify-content: space-between;
        }

        .label {
            display: block;
            margin-bottom: 5px;
        }

        .value {
            display: block;
        }
    }

    .divider {
        @include border-bottom;

        margin-bottom: 15px;
    }
}

.product-wrapper {
    @include product-wrapper();

    .product-details {
        .product-information {
            .price-excludes,
            .price-explained,
            .finance-options {
                display: flex;
                margin: 0 0 15px;
            }

            .step-three {
                position: relative;

                &.fetching {
                    @include fetching;
                }

                .title {
                    padding: 16px 0;
                    @include border-bottom;
                }

                .item {
                    margin: 16px 0;
                    display: flex;
                    align-items: center;
                    text-transform: capitalize;

                    &.ring,
                    &.stone {
                        .image {
                            margin-right: 8px;
                            width: 32px;
                            height: 32px;
                        }
                    }

                    &.stone .image {
                        padding: 4px;
                    }

                    &.signature-stone {
                        justify-content: flex-start;
                    }

                    .icon-stone-modal-info {
                        margin-left: 5px;
                        cursor: pointer;

                        &:before {
                            width: 22px;
                            height: 22px;
                            font-size: 18px;
                            line-height: 22px;
                            color: $blue;
                        }
                    }

                    .remove-button {
                        margin-left: auto;
                        height: 24px;
                        flex: 0 0 24px;
                        font-size: 12px;
                        color: $grey-500;
                        cursor: pointer;
                        border-radius: 50%;
                        background-color: $grey-200;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        user-select: none;
                    }
                }

                .size-and-engraving {
                    margin-top: 24px;

                    @include min-width(640) {
                        display: flex;
                    }

                    .size {
                        @include min-width(640) {
                            width: 200px;
                        }
                    }

                    .engraving {
                        margin-top: 24px;

                        @include min-width(640) {
                            margin: 0 0 0 20px;
                        }
                    }
                }
            }
        }

        .product-customization {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            flex-wrap: wrap;
            //max-height: 500px;

            .product-variation {
                width: 100%;
                @include border-bottom;

                padding: 0 0 15px;
                margin: 0 0 25px;

                .label {
                    display: flex;
                    font-size: 14px;
                    line-height: 1em;
                    margin: 0 0 15px;
                    align-items: center;

                    .additional-options {
                        margin-left: auto;
                        text-decoration: underline;
                        cursor: pointer;
                    }

                    :deep(.tooltip-trigger) {
                        &:after {
                            line-height: 1rem;
                            font-size: 1rem;
                            margin-left: 5px;
                        }
                    }
                }

                .shape-variations {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;

                    .variation {
                        margin: 0 10px 10px 0;
                        flex-shrink: 0;

                        .link {
                            display: block;

                            .image {
                                object-fit: contain;
                                width: 28px;
                                height: 28px;
                                opacity: 0.4;
                            }

                            &.router-link-active {
                                border-bottom: 1px solid rgba($blue, 0.5);

                                .image {
                                    filter: invert(26%) sepia(59%)
                                        saturate(622%) hue-rotate(179deg)
                                        brightness(91%) contrast(84%);
                                    opacity: 1;
                                }
                            }

                            .name {
                                width: 28px;
                                height: 28px;
                                background: $grey-200;
                                border-radius: 50%;
                                display: block;
                                font-size: 0;
                            }
                        }
                    }
                }

                .enquire-shape {
                    background: $blue;
                    color: $white;
                    padding: 20px 20px 25px;
                    position: relative;
                    font-size: 0.875rem;

                    .th-button {
                        margin: 15px 0 0;
                    }

                    .title {
                        font-size: 1.125rem;
                        display: block;
                        margin: 0 50px 20px 0;
                    }

                    .enquire-shape-close {
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        top: 10px;
                        right: 5px;
                        text-align: center;
                        line-height: 40px;
                    }
                }

                .metal-variations {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0 0 10px;

                    .variation {
                        width: 28px;
                        height: 28px;
                        margin: 0 10px 0 0;

                        .link {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                            background: #c8c8c8;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            &.router-link-active {
                                border: 1px solid $blue;
                                box-shadow: inset 0 0 0 3px $white;
                            }
                        }
                    }
                }

                .signature-stone-variations {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0 0 10px;

                    .variation {
                        width: 28px;
                        height: 28px;
                        margin: 0 10px 10px 0;
                        position: relative;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 85%;
                            height: 85%;
                        }

                        &.active {
                            &:before {
                                content: '';
                                height: 0;
                                border-bottom: 1px solid $blue;
                                display: block;
                                bottom: -5px;
                                left: 0;
                                right: 0;
                                margin: 0 auto;
                                position: absolute;
                            }

                            img {
                                width: 95%;
                                height: 95%;
                            }
                        }
                    }
                }

                .threedium-type-test-variations {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    margin: 0 0 10px;

                    .variation {
                        width: 28px;
                        height: 28px;
                        margin: 0 10px 10px 0;
                        position: relative;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.band-type {
                            width: unset;
                        }

                        a {
                            display: block;
                            width: 100%;
                            height: 100%;
                        }

                        img {
                            width: 85%;
                            height: 85%;
                        }

                        &.active {
                            &:before {
                                content: '';
                                height: 0;
                                border-bottom: 1px solid $blue;
                                display: block;
                                bottom: -5px;
                                left: 0;
                                right: 0;
                                margin: 0 auto;
                                position: absolute;
                            }

                            img {
                                width: 95%;
                                height: 95%;
                            }
                        }
                    }
                }
            }
        }

        .product-cta {
            .enquiry-message {
                background: $stone-2;
                display: block;
                padding: 15px 20px;
                margin: 0 0 20px;
                font-size: 0.875rem;
            }
        }

        .customize-further {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.product-customization-enter-active,
.product-customization-leave-active,
.step-three-enter-active,
.step-three-leave-active {
    transition: all 0.45s ease;
    overflow-y: hidden;
}

.price-explained-container {
    :deep(.tooltip-trigger) {
        display: inline-flex;
    }
}

.product-customization-enter-from,
.product-customization-leave-to,
.step-three-enter-from,
.step-three-leave-to {
    max-height: 0 !important;
    opacity: 0;
    overflow-y: hidden;
}
</style>
